import { Injectable } from "@angular/core";
import { IDatabaseConnectionHolderWithFields } from "@coso-replicator/core";
import { Observable } from "rxjs";

@Injectable()
export abstract class ADatabaseConnectionsService {
  abstract get(): Observable<IDatabaseConnectionHolderWithFields[]>
  abstract isInUse(name: string): Observable<boolean>
  abstract create(dto: IDatabaseConnectionHolderWithFields): Observable<void>
  abstract update(name: string, dto: IDatabaseConnectionHolderWithFields): Observable<void>
  abstract delete(name: string): Observable<void>
}
